import React from 'react';
import { Link } from '../../../../Link';
import { MiniHeroImage } from '../MiniHeroImage';
import { CardProps } from './CollectionCard';

export function CollectionCardMiniHero({ card }: CardProps): React.ReactNode {
  const hasBackgroundImage = Boolean(
    card.background.desktopImageUrl ||
      card.background.tabletImageUrl ||
      card.background.mobileImageUrl
  );

  const wrapperFallbackHeight = hasBackgroundImage ? '' : 'min-h-[10rem]';

  return (
    <div key={card.id} className="select-none">
      <Link destination={card.destination}>
        <div
          className={`relative w-full overflow-hidden hover:scale-s transition-transform ${wrapperFallbackHeight}`}
          style={{ backgroundColor: card.background.backgroundColor }}
        >
          {hasBackgroundImage ? (
            <MiniHeroImage
              mobileImageUrl={card.background.mobileImageUrl}
              tabletImageUrl={card.background.tabletImageUrl}
              desktopImageUrl={card.background.desktopImageUrl}
              alt=""
            />
          ) : null}
          {card.image.url ? (
            <img
              src={card.image.url}
              alt={card.title ?? ''}
              className="absolute inset-0 z-10 m-auto h-16 w-auto max-w-[60%] object-contain"
            />
          ) : null}
        </div>
      </Link>
    </div>
  );
}
